// Prefix a public-root path with Vite's BASE_URL so it resolves correctly
// under sub-path deployments (e.g. https://forwaro.com/new/).
//
// Use for EVERY reference to /brand, /editorial, /placeholders, /products
// static assets in TSX/TS source — Vite only rewrites paths in HTML/CSS,
// not JS string literals.
export const asset = (path: string): string => {
  const base = import.meta.env.BASE_URL; // always trailing slash
  return base + path.replace(/^\//, "");
};
